var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Http from 'axios';
import { EventTracking, EventType } from '@app/tracking';
export default Vue.extend({
    data: function () { return ({
        loading: false,
        results: [],
        showLimit: 5,
        searchQuery: '',
        resultTypeIcons: {
            'Nitrous\\Core\\Block': 'align-left',
            'RF\\Blog\\Post': 'newspaper',
            'RF\\Event\\Event': 'calendar-alt',
            'RF\\Shopify\\Product': 'bags-shopping'
        }
    }); },
    computed: {
        isSearchOpen: function () {
            return this.$store.Search.STATE.isOpen;
        },
        filteredResults: function () {
            return this.results.slice(0, this.showLimit);
        }
    },
    created: function () {
        document.addEventListener('keydown', this.handleGlobalKeyDownEvent);
    },
    destroyed: function () {
        document.removeEventListener('keydown', this.handleGlobalKeyDownEvent);
    },
    methods: {
        search: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.searchQuery.length < 3) {
                                return [2 /*return*/];
                            }
                            this.loading = true;
                            return [4 /*yield*/, this.$helpers.debounce(500)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, Http.get("/api/search?query=".concat(encodeURI(this.searchQuery)))];
                        case 2:
                            response = _a.sent();
                            this.loading = false;
                            this.results = response.data.map(function (item) { return item.searchResult; });
                            EventTracking.dispatch(EventType.Track, {
                                category: 'Search',
                                action: 'Results',
                                label: this.searchQuery,
                                value: this.results.length
                            });
                            return [2 /*return*/];
                    }
                });
            });
        },
        handleResultClick: function (result) {
            this.close();
            EventTracking.dispatch(EventType.Track, {
                category: 'Search',
                action: 'Click',
                label: 'Result',
                value: this.getResultPathname(result)
            });
        },
        close: function () {
            this.$store.Search.ACTIONS.close();
            this.results = [];
            this.searchQuery = '';
        },
        handleGlobalKeyDownEvent: function (e) {
            if (e.keyCode == 27 /* ESC */) {
                this.close();
            }
        },
        getResultPathname: function (result) {
            var url = new URL(result.url);
            return url.pathname + url.hash;
        }
    },
    watch: {
        isSearchOpen: function (val) {
            var _this = this;
            if (val) {
                setTimeout(function () {
                    _this.$refs.input.focus();
                }, 300);
                EventTracking.dispatch(EventType.Track, {
                    category: 'Search',
                    action: 'Open',
                });
            }
        }
    },
    filters: {
        strLimit: function (value, limit) {
            if (limit === void 0) { limit = 200; }
            if (value.length > limit) {
                return value.substring(0, limit) + ' ...';
            }
            return value;
        },
        highlight: function (content, query) {
            var regExp = new RegExp(query, 'gi');
            return content.replace(regExp, function (str) { return '<span class="highlight">' + str + '</span>'; });
        }
    }
});
